var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface220209555"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 40 0 L 40 10 L 50 10 L 50 0 Z M 33 5 L 33 11 L 29 11 L 29 13 L 33 13 L 33 19 L 39 19 L 39 17 L 35 17 L 35 7 L 39 7 L 39 5 Z M 18 7 L 18 17 L 28 17 L 28 7 Z M 13 11 L 13 24 L 11 24 L 11 26 L 13 26 L 13 39 L 17 39 L 17 37 L 15 37 L 15 13 L 17 13 L 17 11 Z M 40 14 L 40 24 L 50 24 L 50 14 Z M 0 18 L 0 32 L 10 32 L 10 18 Z M 40 26 L 40 36 L 50 36 L 50 26 Z M 33 31 L 33 37 L 29 37 L 29 39 L 33 39 L 33 45 L 39 45 L 39 43 L 35 43 L 35 33 L 39 33 L 39 31 Z M 18 33 L 18 43 L 28 43 L 28 33 Z M 40 40 L 40 50 L 50 50 L 50 40 Z M 40 40 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.53064c10.svg";
export { ForwardRef as ReactComponent };